import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { AuthContainer } from 'containers'
import { Container } from 'components'

export const HomePageTabs = () => {
  const history = useHistory()
  const { path } = useRouteMatch()
  const { pathname } = useLocation()
  const { accessLevels } = AuthContainer.useContainer()

  const tabClasses = 'py-3 mx-3'
  const activeTabClasses = 'border-b-2 border-primary text-primary'
  const inactiveTabClasses = 'border-b-2 border-white text-dark-body'

  const getTabClasses = (url: string, pathname: string) =>
    pathname.includes(url) ? `${tabClasses} ${activeTabClasses}` : `${tabClasses} ${inactiveTabClasses}`

  return (
    <div className="flex pt-1 text-lg shadow-md">
      <Container>
        <div className="flex flex-col md:flex-row">
          {accessLevels.includes('Supplier Reports') && (
            <button
              className={getTabClasses(`${path}/supplier-reports`, pathname)}
              onClick={() => {
                history.push(`${path}/supplier-reports`)
              }}
            >
              Supplier Reports
            </button>
          )}
          {accessLevels.includes('Manage Access') && (
            <button
              className={getTabClasses(`${path}/user-access`, pathname)}
              onClick={() => {
                history.push(`${path}/user-access`)
              }}
            >
              Manage Access
            </button>
          )}
          {accessLevels.includes('Manage Communications') && (
            <button
              className={getTabClasses(`${path}/communication`, pathname)}
              onClick={() => {
                history.push(`${path}/communication`)
              }}
            >
              Manage Communications
            </button>
          )}
          {accessLevels.includes('Supplier Admin') && (
            <button
              className={getTabClasses(`${path}/supplier-admin`, pathname)}
              onClick={() => {
                history.push(`${path}/supplier-admin`)
              }}
            >
              Supplier Admin
            </button>
          )}
          {accessLevels.includes('Consolidator/Haulier Admin') && (
            <button
              className={getTabClasses(`${path}/consolidator-haulier-admin`, pathname)}
              onClick={() => {
                history.push(`${path}/consolidator-haulier-admin`)
              }}
            >
              Consolidator/Haulier Admin
            </button>
          )}
        </div>
      </Container>
    </div>
  )
}
